// Opening help from anywhere (a Setup Checklist row, a screen) without passing props through the shell:
// a window event the main layout listens to. The layout owns the ? panel and the Help Centre.

import { STORAGE_KEYS } from 'auth/storageKeys';
import type { HelpPageInfo } from 'api/services/helpService';

export const OPEN_HELP_EVENT = 'crs:open-help';

export interface OpenHelpDetail {
  /** The page to show; the screen in front when omitted. */
  pageId?: string;
  /** true = the Help Centre; false = the side panel. */
  centre?: boolean;
}

export const openHelp = (pageId?: string) =>
  window.dispatchEvent(new CustomEvent<OpenHelpDetail>(OPEN_HELP_EVENT, { detail: { pageId, centre: false } }));

export const openHelpCentre = (pageId?: string) =>
  window.dispatchEvent(new CustomEvent<OpenHelpDetail>(OPEN_HELP_EVENT, { detail: { pageId, centre: true } }));

/** Pages every signed-in user sees, whatever their screens. */
const GENERAL_SECTIONS = ['Getting Started', 'FAQ'];

/**
 * The Help Centre lists the pages of the screens the user can open, plus the general pages (design Q3):
 * a cashier does not need setup pages. A page id is a screen's module id.
 */
export const visibleHelpPages = (pages: HelpPageInfo[]): HelpPageInfo[] => {
  let visible: string[] = [];
  try { visible = JSON.parse(localStorage.getItem(STORAGE_KEYS.RBAC_VISIBLE_MODULES) || '[]'); } catch { visible = []; }
  const set = new Set(visible);
  return pages.filter((p) => GENERAL_SECTIONS.includes(p.section) || set.has(p.id));
};
